import { render, staticRenderFns } from "./eachClassify.vue?vue&type=template&id=22f3289c&scoped=true"
import script from "./eachClassify.vue?vue&type=script&lang=js"
export * from "./eachClassify.vue?vue&type=script&lang=js"
import style0 from "./eachClassify.vue?vue&type=style&index=0&id=22f3289c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3289c",
  null
  
)

export default component.exports